import { Input } from "reactstrap";
import {
  MaterialRequestStatus,
  MaterialRequestStatusMap,
  MaterialRequestSourceType,
  MaterialRequestSourceTypeLabel,
} from "features/MaterialRequests/constants/material-request.constants";

export type MaterialRequestListFiltersProps = {
  statusFilter: string;
  sourceTypeFilter: string;
  sourceIdFilter: number | "";
  onStatusChange: (value: string) => void;
  onSourceTypeChange: (value: string) => void;
  onSourceIdChange: (value: number | "") => void;
};

const LIST_STATUS_OPTIONS = [
  MaterialRequestStatus.REQUESTED,
  MaterialRequestStatus.APPROVED,
  MaterialRequestStatus.REJECTED,
  MaterialRequestStatus.CANCELLED,
] as const;

export default function MaterialRequestListFilters({
  statusFilter,
  sourceTypeFilter,
  onStatusChange,
  onSourceTypeChange,
}: MaterialRequestListFiltersProps) {
  return (
    <div className="d-flex align-items-center gap-2">
      <Input
        type="select"
        className="form-select"
        style={{ width: 150 }}
        value={statusFilter}
        onChange={(e) => onStatusChange(e.target.value)}
      >
        <option value="">All statuses</option>
        {LIST_STATUS_OPTIONS.map((s) => (
          <option key={s} value={s}>
            {MaterialRequestStatusMap[s]?.label ?? s}
          </option>
        ))}
      </Input>
      <Input
        type="select"
        className="form-select"
        style={{ width: 160 }}
        value={sourceTypeFilter}
        onChange={(e) => onSourceTypeChange(e.target.value)}
      >
        <option value="">All sources</option>
        {(
          Object.keys(
            MaterialRequestSourceType,
          ) as (keyof typeof MaterialRequestSourceType)[]
        ).map((k) => {
          const v = MaterialRequestSourceType[k];
          return (
            <option key={v} value={v}>
              {MaterialRequestSourceTypeLabel[v]}
            </option>
          );
        })}
      </Input>
    </div>
  );
}
